import React, { type FC, type PropsWithChildren, useLayoutEffect, useRef, useState } from 'react';
import { Tooltip } from '@bynder/design-system';
import { Title as TitleStyled } from './Header.styled';

type TitleProps = PropsWithChildren<{
    isBadgeShown?: boolean;
}>;

const Title: FC<TitleProps> = ({ children, ...props }) => {
    const title = useRef<HTMLDivElement>(null);
    const [isTruncated, setIsTruncated] = useState(false);

    useLayoutEffect(() => {
        if (!title.current) {
            return;
        }

        const checkTruncate = () => {
            setIsTruncated(title.current.scrollWidth > title.current.clientWidth);
        };

        checkTruncate();

        const resizeObserver = new ResizeObserver(checkTruncate);
        resizeObserver.observe(title.current);

        return () => resizeObserver.disconnect();
    }, []);

    return (
        <Tooltip isOpen={isTruncated ? undefined : false} content={isTruncated ? children : undefined}>
            <TitleStyled ref={title} {...props}>
                {children}
            </TitleStyled>
        </Tooltip>
    );
};

export default Title;
